<template>
  <div class="login">
    <div class="loginNotice">
      <div class="notice-header">
        <img src="../../assets/images/noticeHD.png" alt />
      </div>
      <div class="notice-content" v-html="noticeInfo"></div>
    </div>
    <div class="loginForm" v-if="false">
      <img src="../../assets/images/logo2.png" />
      <div :class="{ redborder: this.active == 1 }">
        <img src="../../assets/images/account.png" />
        <input placeholder="请输入您的邮箱账号" v-model="login.account" @focus="activeSet(1)" @blur="activeSet(0)" />
      </div>
      <div class="pwd" :class="{ redborder: this.active == 2 }">
        <img src="../../assets/images/pwd.png" />
        <input placeholder="请输入您的密码" type="password" v-model="login.password" @focus="activeSet(2)" @blur="activeSet(0)" />
      </div>
      <div class="verifyCode" :class="{ redborder: this.active == 3 }">
        <img src="../../assets/images/verifyCode.png" />
        <input placeholder="验证码" v-model="login.captcha" @focus="activeSet(3)" @blur="activeSet(0)" />
        <!-- <verifyCode :identifyCode="this.captcha" @click.native="getVeficationCode()" /> -->
        <img :src="captcha" @click="getVeficationCode()" style="width: 100px;height: 38px;" />
      </div>
      <div class="link">
        <div class="btns">
          <!-- <a class="register" @click="dialogTableVisible = true">
            <img src="../../assets/images/enter.png" />
            <p>校外用户须知</p>
          </a>-->
          <router-link to="/register" class="register">
            <img src="../../assets/images/enter.png" />
            <p>校外注册</p>
          </router-link>
          <div class="xiaonei" @click="_login1">
            <p>校内登录</p>
          </div>
        </div>
        <router-link tag="p" to="/forget">忘记密码</router-link>
      </div>
      <div class="op">
        <button class="loginbtn" @click="_login">登录</button>
        <!-- <button class="loginbtn" @click="_login1">登录</button> -->
      </div>
    </div>

    <!-- 校内登录 -->
    <div class="loginForm">
      <img src="../../assets/images/logo2.png" />
      <div class="op" style="h300px">
        <button class="loginbtn" @click="_login1">校内团体预约登录</button>
      </div>
    </div>

    <el-dialog title="身份选择" :visible.sync="infoShow" class="closeModal">
      <div class="dialog-title">由于您的身份为校内个人/党团，请选择您的具体身份</div>
      <div class="radio-wrap">
        <el-radio v-model="radio" label="1">校内个人</el-radio>
        <el-radio v-model="radio" label="2">校内团体</el-radio>
      </div>

      <div class="dialog-button-wrap">
        <el-button plain style="margin: 0px 30px">取消</el-button>
        <el-button type="danger" @click.stop="sure" style="margin: 0px 30px">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog title="温馨提示" :visible.sync="dialogTableVisible">
      <div class="dialogTable-content-wrap">
        <i class="el-icon-warning" type="primary"></i>
        <p class="dialogTable-content">根据学校出入校相关规定，博物馆目前仅向有入校权限的观众开放，无法为所有校外观众办理入校手续，请您见谅。</p>
      </div>
      <div class="dialogTable-button">
        <span class="button-content" @click="dialogTableVisible = false">知道了</span>
      </div>
    </el-dialog>
    <el-dialog title="预约未处理提示" :visible.sync="notice">
      <div class="dialogTable-content-wrap">
        <i class="el-icon-warning" type="primary"></i>
        <p class="dialogTable-content">{{ message }}</p>
      </div>
      <div class="dialogTable-button">
        <span class="button-content" @click="notice = false">知道了</span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import verifyCode from "@/components/util/identify.vue";
import {
  getVeficationCode,
  oauthLogin,
  login,
  getUserInfo,
  getNotice
} from "@/libs/api";
export default {
  data () {
    return {
      notice: false,
      dialogTableVisible: false,
      userInfo: {},
      active: 0,
      widthT: "25%",
      radio: "2",
      message: "",
      infoShow: false,
      login: {
        account: "",
        password: "",
        captcha: ""
      },
      captcha: "",
      captchaId: "",
      noticeInfo: "" // 公告信息
    };
  },
  components: {
    verifyCode: verifyCode
  },
  methods: {
    _login1: function () {
      window.location.href = Global.loginUrl + Global.REDIRECTURL;
    },
    //确认身份
    sure () {
      sessionStorage.setItem("party", this.radio);
      this.$store.commit("updateAccountInfo", {
        ...this.userInfo,
        party: this.radio
      });
      window.location.href =
        window.location.href.split("?")[0] + "#/home/activitySelect";
    },

    _login: function () {
      this.vefication(iRet => {
        if (iRet) {
          /**上线需要调整 */
          login(
            this.login.account,
            this.login.password,
            this.login.captcha,
            this.captchaId
          ).then(res => {
            // login(this.login.account, this.login.password, this.captcha, this.captchaId).then(res => {
            if (res.status) {
              sessionStorage.setItem("token", res.content.token);
              this.$store.commit("updateToken", res.content.token);
              getUserInfo().then(re => {
                this.userInfo = re.content;
                sessionStorage.setItem("userInfo", JSON.stringify(re.content));
                let party = 1;
                if (re.content.flag == 40 || re.content.flag == 20) {
                  party = 2;
                }
                this.$store.commit("updateAccountInfo", {
                  ...re.content,
                  party: 1
                });
                if (re.content.flag == 10) {
                  //弹出身份选择  让用户选择自己的身份
                  // this.infoShow = true;

                  // 不选择很身份直接登录
                  this.sure()
                  return;
                }
                // 校外人员登录之后，判断是否有两天记录未通过的预约记录
                if (re.content.flag == 30 || re.content.flag == 40) {
                  if (re.content.isRemind) {
                    this.notice = true;
                  }
                }
                sessionStorage.setItem("party", party);
                this.$router.push("home");
              });
              return;
            } else {
              this.$alert(res.message, "提示", {
                confirmButtonText: "确定",
                callback: action => { }
              });
              this.getVeficationCode();
            }
          });
        }
      });
    },
    vefication: function (callback) {
      if (this.login.password === "") {
        this.$alert("请输入账号的密码", "提示", {
          confirmButtonText: "确定",
          callback: action => {
            callback(false);
          }
        });
        /*** 上线需要调整*/
      } else if (!this.login.captcha) {
        this.$alert("验证码错误，请重试！", "提示", {
          confirmButtonText: "确定",
          callback: action => {
            callback(false);
            this.getVeficationCode();
          }
        });
      } else {
        callback(true);
        // this.getVeficationCode();
      }
    },
    getVeficationCode: function () {
      getVeficationCode().then(res => {
        if (res.status) {
          this.captcha = res.content.captchaText;
          this.captchaId = res.content.captchaId;
          /**上线需要调整*/
          // this._login()
        }
      });
    },
    refreshCode: function () {
      var time = 1000 * 60 * 5;
      setInterval(() => {
        this.getVeficationCode();
      }, time);
    },
    activeSet: function (active) {
      this.active = active;
    },
    initIWidth: function () {
      var h =
        document.documentElement.clientHeight || document.body.clientHeight;
      this.widthT = h == 1080 ? "25%" : "22%";
    },
    getNoticeFunc: function () {
      getNotice().then(res => {
        if (res.code == 200) {
          this.noticeInfo = res.data;
        } else {
          this.$alert(res.message, "提示", {
            confirmButtonText: "确定",
            callback: action => { }
          });
        }
      });
    }
  },
  mounted () {
    this.message = Global.noticeMessage;
    this.initIWidth();
    this.getVeficationCode();
    this.refreshCode();
    let str = window.location.href;
    if (str.indexOf("code=") != -1) {
      let code = str.split("code=")[1].split("&")[0];
      oauthLogin(code).then(res => {
        if (res.status) {
          let userInfo = res.data.userInfoDTO;
          this.$store.commit("updateAccountInfo", userInfo);
          sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
          this.$store.commit("updateToken", res.content.token);
          if (userInfo.flag == 10) {
            // this.infoShow = true;

            // 不选择很身份直接登录
            this.sure()
          } else {
            let party = 1;
            if (userInfo.flag == 20 || userInfo.flag == 40) party = 2;
            sessionStorage.setItem("party", party);
            window.location.href = str.split("?")[0] + "#/home/activitySelect";
          }
        }
      });
    }
  },
  created () {
    this.getNoticeFunc();
  }
};
</script>
<style lang="less" scoped>
.login {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: flex-start;

  .loginNotice {
    background-image: url('~@/assets/images/noticeBG.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0px 7.56px 47.88px rgba(0, 0, 0, 0.04);
    border-radius: 25.2px;
    width: 506.21px;
    height: 663.39px;
    margin: 10.64vh auto 0 285px;
    padding-top: 20px;
    overflow: hidden;
    // margin-right: auto;
    // margin-top: 10.64vh;
  }

  .notice-header {
    margin-top: -15px;
  }

  .notice-content {
    font-family: PingFang SC;
    line-height: 24px;
    height: 560px;
    overflow-y: auto;
    letter-spacing: 0.2em;
    padding: 10px 30px 20px 30px;
  }

  // 好看的滚动条
  .notice-content::-webkit-scrollbar {
    /*整体样式*/
    width: 10px;
    height: 2px;
  }

  .notice-content::-webkit-scrollbar-track {
    /*轨道*/
    background: #f5f7fe;
    border-radius: 0px;
    transform: rotate(-180deg);
  }

  .notice-content::-webkit-scrollbar-thumb {
    /*滚动条小方块*/
    background: #dae2ff;
    border-radius: 0px;
    transform: rotate(-180deg);
  }

  @media screen and (min-width: 1241px) and (max-width: 1400px) {
    .loginForm {
      width: 510px !important;
    }
  }

  .loginForm {
    margin-right: 260px;
    width: 400px;
    background-image: url('~@/assets/images/login_baclground.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 5px;
    margin-top: 10.64vh;

    > img {
      margin-top: 4.35vh;
      margin-bottom: 4.35vh;
    }

    .redborder {
      border: 1.5px solid red;
    }

    > div {
      width: 87%;
      box-sizing: border-box;
      background-color: white;
      height: 5.55vh;
      padding-left: 20px;
      margin-bottom: 1.85vh;
      display: flex;
      align-items: center;

      input {
        outline: none;
        border: none;
        font-size: 15px;
        margin-left: 5px;
        flex: 1;
        margin-left: 5%;
      }
    }

    .op {
      padding-left: unset;
      background-color: unset;
      margin-bottom: 4vh;

      .loginbtn {
        cursor: pointer;
        width: 100%;
        background-color: #ae0c2a;
        color: white;
        border: none;
        height: 5.74vh;
        letter-spacing: 5px;
        margin-top: 4.16vh;
        margin-bottom: 2.78vh;
        font-size: 17px;
      }
    }

    .link {
      height: auto;
      background-color: unset;
      color: #c55066;
      text-decoration: underline;
      display: flex;
      justify-content: space-between;
      margin-bottom: unset;
      padding-left: 5px;
      margin-bottom: 10px;

      .btns {
        display: flex;

        .xiaonei {
          margin-left: 10px;
          cursor: pointer;
        }

        .register {
          display: flex;
          color: #c55066;
          cursor: pointer;

          img {
            margin-right: 10px;
          }
        }
      }

      > p {
        cursor: pointer;
      }
    }
  }
}

input {
  color: black;
}

input:-webkit-autofill {
  box-shadow: 0 0 0px 1000px white inset !important;
}

.verifyCode {
  user-select: none;
}

.dialogTable-content-wrap {
  display: flex;
}

.dialogTable-content {
  margin-left: 15px;
}

.el-icon-warning {
  color: #e6a23c;
  font-size: 30px;
}

.dialogTable-button {
  width: 100%;
  display: flex;
  justify-content: flex-end;

  .button-content {
    padding: 5px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ae0c2a;
    margin-top: 25px;
    color: white;
    border-radius: 5px;
    width: 65px;
    font-size: 14px;
    cursor: pointer;
  }
}
</style>
<style >
.el-dialog {
  background-image: url('~@/assets/images/registerbg.jpg');
  background-repeat: no-repeat;
  background-position: bottom;
  background-color: #f1eee7;
  width: 500px !important;
}

.el-dialog__header {
  border: 1px solid #dadada;
  padding-bottom: 22px;
}

.el-pagination {
  padding: 0;
}

.radio-wrap {
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog-title {
  text-align: center;
}

.dialog-button-wrap {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/single/login.vue